// extracted by mini-css-extract-plugin
export default {"container":"cardStyle_container__qiSRz","deck":"cardStyle_deck__pd2vf"};